<template>
  <ContentItem v-for="content in contentList" :key="content.id" :contentId="content.id" :contentData="content.content ? content.content : null" :adminMode="adminMode" />
</template>

<script>
import ContentItem from './ContentItem'

export default {
  props: {
    'adminMode': {
      type: Boolean,
      default: false 
    },
    eventId: {
      type: Number,
      required: true,
    },
  },
  components: {
    ContentItem
  },
  mounted() {
    this.getContentList();
    window.Echo.channel(`events.${this.eventId}`)
      .listen("NewContent", (e) => {
        this.contentList.unshift({ id: e.content_id, content: e.content });
      })
      .listen("ContentDeleted", (e) => {
        const index = this.contentList.findIndex(content => content.id == e.content_id);
        console.log("Index: ", index);
        if (index > -1) {
          this.contentList.splice(index, 1); 
        }
      });
    // Handle reconnection
    window.Echo.connector.pusher.connection
      .bind('connected', (payload) => {
        console.log('connected!', payload);
        if(this.unavailableSince) {
          this.getContentList();
          this.unavailableSince = null;
        }
      })
      .bind('unavailable', (payload) => {
        console.log("unavailable!", payload)
        this.unavailableSince = new Date();
      });
  },
  data() {
    return {
      contentList: [],
      unavailableSince: null,
    };
  },
  methods: {
    async getContentList() {
      let response = await axios.get(`/events/${this.eventId}/content/list`);
      let contentList = response.data;
      this.contentList = contentList.slice().reverse().map((content) => {
        return {
          id: content.id,
          content: content
        }
      });
    },
  },
};
</script>
